import React from 'react';
import MissionIMG from '../assets/mission-azf.png';

const MissionSection = () => (
  <section className="missionSection" id="about">
    <div className="missionLeft">
      <div className="missionImageWrapper">
        <img
          src={MissionIMG}
          alt="Student Mission"
          className="missionMainImage"
        />
      </div>
    </div>
    <div className="missionRight">
      <div className="missionAbout">About Us</div>
      <h2 className="missionTitle">Mission</h2>
      <p className="missionDesc">
        To provide financial support to committed students pursuing Islamic education through classes, events, conferences, and academics. A world where financial constraints do not hinder dedicated individuals from pursuing in-depth Islamic knowledge and scholarship.
      </p>
      <a href="https://docs.google.com/forms/d/1eRGV-rcK4nzIKdE4zWMovypxxJat4Xhl5zP2A2vqtpQ/viewform?ts=6812c89d&edit_requested=true" className="missionApplyBtn">Apply for a Grant &rarr;</a>
    </div>
  </section>
);

export default MissionSection;
